import { Alert } from 'antd';

import { SOCIAL_DISCLOSURE_FALLBACK, socialDisclosure, type SocialDataSource } from '@/lib/social';

/**
 * REDFOX 社交分区透明 banner（§D6）：渲 API `disclosure`，仅缺失时用保守 fallback。
 * 让 social / 非-VOC 边界在读任何指标前可见；**禁前端自写更强/更弱营销文案**。
 */
export default function SocialDisclosureBanner({
  source,
}: {
  source: Pick<SocialDataSource, 'disclosure'> | null;
}) {
  const text = source ? socialDisclosure(source) : SOCIAL_DISCLOSURE_FALLBACK;
  return (
    <Alert
      type="info"
      showIcon
      message="社交信号层（来自 REDFOX，非 VOC/NPS）"
      description={<span className="text-[12px]">{text}</span>}
    />
  );
}
